<template>
  <v-dialog v-model="overlay" max-width="300" persistent>
    <v-card>
      <v-card-text align="center">
        <br />
        <br />
        <v-progress-circular
          :size="30"
          color="blue"
          indeterminate
        ></v-progress-circular>
        <br />
        <br />
        <h3 class="text-loading-color">Loading...</h3>
        <br />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      overlay: true,
    };
  },
};
</script>

<style></style>
